/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Org_Contract_Approve_TermsInputs */



/**
* | output |
* | --- |
* | "You are agreeing to {seats} seats and {amount} of prepaid usage for this term." |
*
* @param {Partner_Org_Contract_Approve_TermsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_terms = /** @type {((inputs: Partner_Org_Contract_Approve_TermsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_TermsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie stimmen ${i?.seats} Plätzen und ${i?.amount} vorausbezahlter Nutzung für diese Laufzeit zu.`)
	return /** @type {LocalizedString} */ (`You are agreeing to ${i?.seats} seats and ${i?.amount} of prepaid usage for this term.`)
});